import AbstractValidator from './AbstractValidator';

export default class Regex extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        regexNotMatch: 'Die Eingabe hat ein ungültiges Format.',
    };

    run()
    {
        let pattern = this._options.pattern;
        let flags   = '';

        // replace PCRE unicode-codepoints "\x{...}" to ECMA-format "\u..."
        pattern = pattern.replace(/\\x\{([\da-f]{4,6})\}/ig, '\\u$1');

        if (pattern.substr(0, 1) === '#')
        {
            for (let i = pattern.length; i > 0; i--)
            {
                if (pattern[i] === '#')
                {
                    flags   = pattern.substr(i + 1);
                    pattern = pattern.substr(1, i - 1);
                    break;
                }
            }
        }

        let test = new RegExp(pattern, flags);

        if (!test.test(this.value))
        {
            this.error = this.getMessage('regexNotMatch');
        }
    }
}